module.exports = __webpack_public_path__ + "static/media/austria_huong.1fc77d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/austria_huong.jpg
// module id = 399
// module chunks = 0